<form [formGroup]="form" class="time-picker-container">
  <span class="input-label">
    {{ headerText }}
    @if (required) {
      <span class="required-field">*</span>
    }
  </span>
  <span class="input-form-control-container">
    <ion-input
      appTimeInput
      class="form-control"
      [formControlName]="control"
      [ngxTimepicker]="picker"
      [format]="24"
      [disableClick]="true"
      [placeholder]="defaultStartTime"
      [maxlength]="5"
    ></ion-input>
    <ngx-material-timepicker-toggle
      [for]="picker"
      [ngClass]="{ 'alt-spacing': altIconSpacing }"
    >
      <ion-icon [src]="icon" ngxMaterialTimepickerToggleIcon></ion-icon>
    </ngx-material-timepicker-toggle>

    <ngx-material-timepicker
      #picker
      [defaultTime]="form.get(control)?.value || defaultStartTime"
      (timeSet)="inputChanged($event)"
    ></ngx-material-timepicker>
  </span>
</form>
